import React, { useEffect, useState } from "react";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Menu from "components/menu/Menu";
import useAnimation from "utils/hooks/useAnimation";

function MainContainer({ children }) {
  useAnimation();

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.onscroll = function () {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-interlink-white">
      <Menu
        className={`${
          isMenuOpen
            ? "translate-y-0 z-30 opacity-100 overflow-auto transition-all duration-1000"
            : "-translate-y-full -z-50 opacity-0 transition-all duration-1000"
        }`}
        setMenuOpen={setMenuOpen}
      />
      <Navbar scrolled={scrolled} setMenuOpen={setMenuOpen} />
      <div className={`${isMenuOpen ? "hidden" : "inline"}`}>
        {children}
        <Footer />
      </div>
    </div>
  );
}

export default MainContainer;
